import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M4 5H20M4 12H20M4 19H16.5" vectorEffect="non-scaling-stroke" />
	</SVG>
);
